import IntroPage from "./Components/Intro";
import './CSS/App.css';

function App() {
  return (
    <div className="App">
      <IntroPage/>
    </div>
  );
}

export default App;
